import React, { useState,useEffect,useRef } from "react";
import { Grid2, Typography, Button, Box } from "@mui/material";
import logo from "../../../ui-utils/latestPics/aboutus.svg";

import AboutUsMobileViewStyles from "./AboutUsMobileView.module.css";
import en from "../../../i18n/English/Aboutus/aboutus.json";
import hi from "../../../i18n/Hindi/Aboutus/aboutus.json";
import kn from "../../../i18n/Kannada/Aboutus/aboutus.json";
import ma from "../../../i18n/Marathi/Aboutus/aboutus.json";
import gu from "../../../i18n/Gujarati/Aboutus/aboutus.json";
import { useLanguage } from "../../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
  title: 'Leading NSE, BSE & CDSL Trading Platform in India | TradeBoss',
  description: 'Discover TradeBoss, India’s trusted NSE, BSE trading platform for stocks, bonds, mutual funds & IPOs. Empowering NRIs & HNIs for 25+ years.',
  canonical: 'https://tradeboss.co/aboutus',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'Indian trading platform, NSE trading platform, BSE trading platform, stock trading company India, best online broker India, trusted NSE BSE broker, Leading NSE, BSE, CDSL trading platform, Invest in stocks, bonds, Invest in mutual funds, Invest in gold, Invest in IPOs. Trusted by NRIs, HNIs'
    }
  }
}
export default function MobileView() {

   const scrollContainerRef = useRef(null);
    const [isUserScrolling, setIsUserScrolling] = useState(false);

     const { language } = useLanguage();
     const translations = { en, hi, kn ,ma,gu };
   const t = translations[language] || translations.en ;


    const handleUserInteraction = () => {
      setIsUserScrolling(true);
      setTimeout(() => setIsUserScrolling(false), 0); // Resume auto-scroll after 3 seconds of inactivity
    };
  return (
    <Grid2 className={AboutUsMobileViewStyles.outer_card}>
      <DocumentMeta {...meta} />
      {/* <h1 className={AboutUsMobileViewStyles.text_title}>
        {t.heading}
      </h1> */}

      <div className={AboutUsMobileViewStyles.headingContainer}>
        <div className={AboutUsMobileViewStyles.gradientBackground}></div>
        <Typography className={AboutUsMobileViewStyles.text_title} style={{ fontWeight: 600 }}>
          {t.heading}
        </Typography>
      </div>
      <img src={logo} alt="Tradeboss logo" className={AboutUsMobileViewStyles.pic}/>
                <Typography className={AboutUsMobileViewStyles.paragraph}>

        {t.subtxt}<span className={AboutUsMobileViewStyles.subContent} style={{fontWeight:"600"}}>{t.title}</span>{t.subtxt1}

                </Typography>

            <Button className={AboutUsMobileViewStyles.button} href="/support">
        {t.button}
            </Button>


    </Grid2>
  );
}
